class RecommendedProducts extends HTMLElement {
  constructor() {
    super();

    this.isLoaded = false;

    this.recommendationsObserver = new IntersectionObserver(
      (entries) => this.handleIntersect(entries),
      { rootMargin: '0px 0px 200px 0px' }
    );
  }

  connectedCallback() {
    const sectionId = this.dataset.sectionId;
    const expectedWrapperNode = document.querySelector(`#RecommendedProducts-${sectionId}`);

    if (!expectedWrapperNode || !expectedWrapperNode.contains(this)) {
      console.warn(
        `RecommendedProducts: element with sectionId=${sectionId} used outside its wrapper`
      );
      return;
    }

    this.recommendationsObserver.observe(this);
  }

  disconnectedCallback() {
    this.recommendationsObserver.unobserve(this);
  }

  async handleIntersect(entriesArray) {
    if (!Array.isArray(entriesArray) || entriesArray.length === 0) {
      console.warn('RecommendedProducts: IntersectionObserver received empty entries array');
      return;
    }

    const entryNode = entriesArray[0];
    if (!entryNode?.isIntersecting || this.isLoaded) return;

    this.isLoaded = true;
    this.recommendationsObserver.unobserve(this);

    const recommendationsUrl = this.dataset.url;
    if (!recommendationsUrl) return;

    try {
      const response = await fetch(recommendationsUrl);
      if (!response.ok) {
        console.error('RecommendedProducts fetch error:', response.status);
        return;
      }

      const htmlText = await response.text();
      const tempContainerNode = document.createElement('div');
      tempContainerNode.innerHTML = htmlText;

      const fetchedRecommendationsNode = tempContainerNode.querySelector('.product-recommendations');

      if (fetchedRecommendationsNode && fetchedRecommendationsNode.innerHTML.trim().length > 0) {
        this.innerHTML = fetchedRecommendationsNode.innerHTML;
      } else {
        const sectionSelector = '[id^="shopify-section-"]';
        const shopifySectionNode = this.closest(sectionSelector);
        shopifySectionNode?.style && (shopifySectionNode.style.display = 'none');
      }
    } catch (fetchError) {
      console.error('RecommendedProducts fetch exception:', fetchError);
    }
  }
}

customElements.define('recommended-products', RecommendedProducts);
